<template>
<div>
  <div class="main-content">
    <div class="content-block box">
      <div class="content">
        <div class="action-buttons">
          <div class="date-bar">
            <img class="arrow-img" src="@/assets/arrow_left.png" @click="getTransports(month.add(-1, 'months'))" />
            <span class="transport-y-m">{{ month.format("YYYY年M月") }}</span>
            <img class="arrow-img" src="@/assets/arrow_right.png" @click="getTransports(month.add(1, 'months'))">
          </div>
          <div class="box download-buttons">
            <button class="pure-button" @click="csvSum">サマリ（CSV）</button>
            <button class="pure-button detail-csv-button" @click="csvDetail">明細（CSV）</button>
            <button class="pure-button detail-copy-button" @click="showPrintModal = true">明細（印刷）</button>
            <a ref="download" download="" href="" style="display: none;"></a>
          </div>
        </div>
        <div class="transport-area">
          <table class="pure-table" ref="table">
            <thead class="table-header" ref="thead">
              <tr :style="{ width: theadTrWidth }">
                <td class="td-attri">
                  <span class="attribute">属性1</span>
                  <img :src="arrowSrc('attribute1')" @click="sort('attribute1')">
                </td>
                <td class="td-attri">
                  <span class="attribute">属性2</span>
                  <img :src="arrowSrc('attribute2')" @click="sort('attribute2')">
                </td>
                <td class="td-name">氏名</td>
                <td class="td-fee">交通費</td>
                <td class="td-fee">お客様請求</td>
                <td class="td-fee">合計</td>
                <td class="td-check">締め処理</td>
              </tr>
            </thead>
            <tbody ref="tbody" :style="{ height: tbodyHeight + 'px' }">
              <tr ref="tbodyTr" v-for="transport in transports" :key="transport.no">
                <td class="td-attri">{{ transport.Attribute1 }}</td>
                <td class="td-attri">{{ transport.Attribute2 }}</td>
                <td class="td-name">
                  <router-link class="link-name" :to="{name: 'transport_detail', query: { id: transport.UserID, month: month.format('YYYY-MM-DD'), name: transport.Name, checkStatus: transport.Status }}">
                    {{ transport.Name }}
                  </router-link>
                </td>
                <td class="fee td-fee">{{ transport.TransportFee }} 円</td>
                <td class="fee td-fee">{{ transport.ChargeToCustomerFee }} 円</td>
                <td class="fee td-fee">{{ transport.FeeAmount }} 円</td>
                <td class="td-check">
                  <a class="status" @click="changeStatus(transport.UserID)" :style="checkBoxStyle">
                    <img :src="checkBoxSrc(transport.Status)">
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- 印刷ユーザー選択モーダル -->
  <transition name="modal">
    <div class="modal-mask" v-if="showPrintModal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <table>
            <thead>
              <tr>
                <th class="name">氏名</th>
                <th class="check">
                  <input type="checkbox" class="check-header" @change="checkAll" :disabled="0 == transportsWithExpenses.length"/>
                </th>
              </tr>
            </thead>
            <div class="modal-thead">
              <tbody>
                <tr v-if="0 == transportsWithExpenses.length">
                  <span>請求のあるユーザーはいません。</span>
                </tr>
                <tr v-else v-for="transport in transportsWithExpenses" :key="transport.id">
                  <td class="name">{{ transport.Name }}</td>
                  <td class="check">
                    <input type="checkbox" v-model="checkedUser" :value="transport.UserID"/>
                  </td>
                </tr>
              </tbody>
            </div>
          </table>
          <div class="modal-buttons">
            <button class="pure-button modal-button-decision" @click="openPrint">決定</button>
            <button class="pure-button modal-button-cancel" @click="showPrintModal = false">キャンセル</button>
          </div>
        </div>
      </div>
    </div>
  </transition>

</div>
</template>

<script>
import moment from "moment"

export default {
  data() {
    return {
      showPrintModal: false,
      observer: null,
      tableHeight: 0,
      theadHeight: 0,
      tbodyTrWidth: 0,

      transports: {},
      month: moment(),
      checkedUser: [],

      // indexが若い順に全要素がorder byに使われる。
      sortState: [
        { name: "attribute1", rule: "asc" },
        { name: "attribute2", rule: "asc" }
      ]
    }
  },

  beforeMount() {
    let storedSort = this.$store.state.store.transports.sort
    if (Object.keys(storedSort).length != 0) {
      this.sortState = storedSort
    }

    let storedTrasnports = this.$store.state.store.transports.contents
    if (Object.keys(storedTrasnports).length != 0) {
      this.transports = storedTrasnports
      this.month = moment(this.$store.state.store.transports.month)
    }

    this.$emit("send", this.getThisMonthsTransports)
  },

  mounted() {
    this.setScrollTop()
    this.setResizeObserver()
  },

  beforeRouteLeave (to, from, next) {
    this.storeScrollTop()
    next()
  },
  
  beforeDestroy() {
    this.removeResizeObserver()
  },

  watch: {
    transports() {
      this.$nextTick(() => {
        this.getSizeForLayout()
      })
    },

    showPrintModal(newVal) {
      // モーダル消す時はユーザー選択をリセット
      if (newVal == false) {
        this.checkedUser = []
      }
    }
  },

  computed: {
    checkBoxStyle() {
      if (this.$store.state.store.user.auth != 0) {
        return 'pointer-events: none;'
      } else {
        return ''
      }
    },

    arrowSrc() {
      return function(column) {
        let sortRule = this.sortState.find((el) => el.name == column).rule
        return require("@/assets/triangle-" + sortRule +".png")
      }
    },

    checkBoxSrc() {
      return function(status) {
        switch (status) {
          case 0:
            return require("@/assets/ic_unchecked.png")
          case 1:
            return require("@/assets/ic_checked.png")
          default:
            return require("@/assets/ic_bad_check.png")
        }
      }
    },

    // 請求のあるユーザのみ抽出
    transportsWithExpenses() {
      return this.transports.filter( transport =>
        transport.FeeAmount != '0'
      )
    },

    tbodyHeight() {
      return this.tableHeight - this.theadHeight
    },

    theadTrWidth() {
      return this.tbodyTrWidth == 0 ? 'auto' : this.tbodyTrWidth + 'px'
    }
  },

  methods: {
    getThisMonthsTransports() {
      this.getTransports(this.month)
    },

    getTransports(month) {
      let fMonth = month.format("YYYY年M月1日")
      this.$http.get("/transports", {
        params: {
          month: fMonth,
          sortState: this.sortState
        }})
        .then((res) => {
          let transports = res.data.transports
          this.transports = transports
          this.month = month
          this.$store.dispatch("setTrasnports", { month: month, sort: this.sortState, contents: transports })
        })
    },

    sort(column) {
      // 押されたカラムに対応する要素のruleを書き換えて、sortStateの先頭に持っていく
      let state = this.sortState
      let currentRule = state.find((el) => el.name == column).rule
      let newRule = currentRule == "asc" ? "desc" : "asc"
      state = state.filter((el) => el.name != column)
      state.unshift({ name: column, rule: newRule })
      this.sortState = state
      
      this.getTransports(this.month)
    },

    changeStatus(id) {
      this.$http.get("/chekced_status_change", {
        params: {
          id: id,
          month: this.month.format("YYYY年M月D日")
        }})
        .then((res) => {
          let target = this.transports.find((t) => { return (t.UserID === id) })
          target.Status = res.data.status
        })
    },

    csvSum() {
      this.downloadCsv("/transport_data", "交通費サマリ_")
    },

    csvDetail() {
      this.downloadCsv("/transport_detail_data", "交通費詳細_")
    },

    downloadCsv(url, title) {
      this.$http.get(url, {
        params: {
          month: this.month.format("YYYY年M月1日"),
          sortState: this.sortState
        }
      })
      .then((res) => {
        let content = res.data.transports
        let fileName = title + res.data.title + ".csv"
        let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        let blob = new Blob([ bom, content ], { "type" : "text/csv" })

        let downloadDom = this.$refs.download
        downloadDom.download = fileName
        downloadDom.href = window.URL.createObjectURL(blob)
        downloadDom.click()
      })
    },

    checkAll(e) {
      if (e.target.checked) {
        this.transports.map(el => {
          this.checkedUser.push(el.UserID)
        })
      } else {
        this.checkedUser = []
      }
    },

    openPrint() {
      if (this.checkedUser.length == 0) {
        alert('印刷するユーザーを選択してください。')
        return 
      }

      // ソートは表示と揃える
      let users = []
      this.transports.map(el => {
        if (this.checkedUser.includes(el.UserID)) {
          users.push(el.UserID)
        }
      })

      this.showPrintModal = false

      let location = this.$router.resolve({ name: 'transport_details_sheet', query: { month: this.month.format('YYYY年M月D日'), users: users }})
      window.open(location.href)
    },

    setScrollTop() {
      let scroll = this.$store.state.store.transportScrollX
      if (scroll != 0) {
        this.$refs.tbody.scrollTop = scroll
      }
    },

    storeScrollTop() {
      this.$store.dispatch("setTransportListScrollX", this.$refs.tbody.scrollTop)
    },

    setResizeObserver() {
      this.observer = new ResizeObserver(function() {
        this.theadHeight = this.$refs.thead.clientHeight
        if(this.$refs.tbodyTr && 0 < this.$refs.tbodyTr.length) {
          this.tbodyTrWidth = this.$refs.tbodyTr[0].clientWidth
        }
      }.bind(this))

      this.observer.observe(this.$refs.thead)
    },

    removeResizeObserver() {
      this.observer.unobserve(this.$refs.thead)
    },

    getSizeForLayout() {
      this.tableHeight = this.$refs.table.clientHeight - 4
      this.theadHeight = this.$refs.thead.clientHeight
      if(this.$refs.tbodyTr && 0 < this.$refs.tbodyTr.length) {
        this.tbodyTrWidth = this.$refs.tbodyTr[0].clientWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.action-buttons {
  display: flex;
}

.download-buttons {
  margin: 10px;
}

.date-bar {
  width: fit-content;
  height: 30px;
  margin: 10px auto 0px auto;
  display: table;
  align-self: center;

  .transport-y-m {
    display: table-cell;
    vertical-align:middle;
  }

  .arrow-img {
    width: 28px;
    height: 28px;
    display: table-cell;
  }
}

.pure-button {
  background: linear-gradient(135deg, #fff5ee, #bce2e8);
}

.detail-csv-button {
  margin: 0 10px;
  background: linear-gradient(-45deg, #fff5ee, #bce2e8);
}

.detail-copy-button {
  margin: 0 98px 0 0;
}

.transport-area {
  width: 100%;
  max-width: 95%;
  height: calc(100% - 70px);
  overflow-y: hidden;
}

table {
  width: 100%;
  margin: auto;
  table-layout: fixed;

  .td-attri {
    width: 16%;

    .attribute {
      margin-right: 10px;
    }
  }

  .td-name {
    width: 19%;
  }

  .td-fee {
    width: 13%;
  }

  .fee {
    text-align: right;
  }

  .td-check {
    width: 10%;

    .status img {
      width: 20px;
      height: 20px;
    }
  }
}

.link-name {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #4682b4;
}

.link-name::after {
  position: absolute;
  bottom: -3px;
  left: 0;
  content: '';
  width: 100%;
  height: 3px;
  background: radial-gradient(#87ceeb, transparent);
  transform: scale(0, 1);
  transform-origin: center top;
  transition: transform .3s;
}

.link-name:hover::after {
  transform: scale(1, 1);
}

.table-header {
  background: linear-gradient(180deg, #fffaf0, #dcdcdc);
}

//印刷社員モーダル
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 90%;
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;

  table {
    height: 90%;
    width: 100%;

    thead {
      background: linear-gradient(180deg, #fffaf0, #dcdcdc);
    }

    .name {
      width: 100px;
    }

    .check-header{
      margin: 4px 20px 0 1px;
    }

    .check {
      width: 30px;
    }

    .modal-thead {
      overflow-y: scroll;
      height: 95%;

      tbody {
        overflow-y: unset;

        tr {
          border: 1px inset;
        }
      }
    }
  }

  .modal-buttons {
    margin-top: 12px;

    .modal-button-decision {
      margin: 0 55px 0 85px;
      background: linear-gradient(-45deg, #fff5ee, #bce2e8);
    }

    .modal-button-cancel {
      background: linear-gradient(135deg, #ffffb7, #FF6666);
    }
  }
}

.modal-enter, .modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media screen and (min-width: 1200px) {
  table {
    width: 1000px;
  }
}

@media screen and (max-width: 420px) {
  .download-buttons {
    display: none;
  }

  .transport-area {
    height: calc(100% - 55px);
    overflow-x: scroll;
  }

  table {
    table-layout: unset;

    tr {
      table-layout: fixed;
    }

    .td-attri {
      width: 90px;
    }

    .td-name {
      width: 80px;
    }

    .td-fee {
      width: 70px;
    }

    .td-check {
      width: 56px;
    }
  }
}
</style>
